@if (coordinates$ | async; as coordinateDisplays) {
  <div class="mouse-coordinates"
    (pointerenter)="isOverCoordinates(true)"
    (pointerout)="isOverCoordinates(false)"
    (mouseenter)="isOverCoordinates(true)"
    (mouseout)="isOverCoordinates(false)"
    >
    @for (coordinateDisplay of coordinateDisplays; track coordinateDisplay.id) {
      <div class="mouse-coordinates__row">
        @if (coordinateDisplay.label) {
          <span class="mouse-coordinates__label">{{ coordinateDisplay.label }}</span>
        }
        <span class="mouse-coordinates__coordinate">{{ coordinateDisplay.coordinates[0] }}</span>
        <span>|</span>
        <span class="mouse-coordinates__coordinate">{{ coordinateDisplay.coordinates[1] }}</span>
      </div>
    }
  </div>
}
